import react, { useState, useEffect, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { Box, Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import "./homeStyle.css"
import { constants } from '../../util';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-coverflow';
import 'swiper/css/effect-creative';
import { EffectCoverflow, Autoplay, EffectFade, EffectCreative } from 'swiper/modules';
import Footer from '../../components/footer/Footer';

import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { showSignup } from '../../store/slices/configSlice';


export default function Home() {
    const dispatch = useDispatch();

    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isMd = useMediaQuery(theme.breakpoints.down('md'));
    const isXl = useMediaQuery(theme.breakpoints.down('xl'));

    let slides = 4;
    if (isSm) slides = 1;
    else if (isMd) slides = 2;
    else if (isXl) slides = 3;
    

    const handleClick_GetHeard = () => {
        dispatch(showSignup(true))
    }


    return(
        <>
            
            <Box sx={{
                height: '550px',
                width: '100%',
                backgroundColor: '#313233',
                backgroundImage: "url('/assets/img/generic/fondo-azul.svg')",
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                // position:'fixed',
                // top:0,
                zIndex:1
            }}>
                <Box sx={{
                    margin: 0,
                    padding: 0,
                    border: 0,
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    position: 'absolute',
                    backgroundImage: {
                                sxs:'none',
                                xs:'none',
                                sm:"url('/assets/img/generic/forma-azul.svg')",
                                md:"url('/assets/img/generic/forma-azul.svg')",
                                lg:"url('/assets/img/generic/forma-azul.svg')",
                                xl:"url('/assets/img/generic/forma-azul.svg')",
                            },
                    backgroundSize:  {
                                sxs:'0%',
                                xs:'0%',
                                sm:"60%",
                                md:"50%",
                                lg:"40%",
                                xl:"30%",
                            },
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionY: '0px',
                    backgroundPositionX: 'right',
                    zIndex:2
                }}>
                    <Grid container size={12}>
                        {/* <Header /> */}
                        <div style={{width:'100%', height:'80px'}}>&nbsp;</div>
                        <br /><br /><br />
                        <Grid size={{
                                sxs:12,
                                xs:12,
                                sm:7,
                                md:5,
                                lg:5,
                                xl:5,
                            }} 
                            sx={{height:'100%', paddingTop:'40px'}}>
                            <Box sx={{
                                marginLeft:{
                                    sxs:'30px',
                                    xs:'30px',
                                    sm:'100px',
                                    md:'100px',
                                    lg:'100px',
                                    xl:'100px',
                                },
                                marginTop:{
                                    sxs:'20px',
                                    xs:'20px',
                                    sm:'40px',
                                    md:'40px',
                                    lg:'40px',
                                    xl:'40px',
                                },
                                color:'#FFFFFF',
                            }}>
                                <Swiper
                                    style={{width:'100%'}}
                                    effect='creative'
                                    grabCursor={true}
                                    centeredSlides={true}
                                    navigation={true}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    loop={true}
                                    autoplay={{
                                        disableOnInteraction: false,
                                        delay: 2000,
                                    }}
                                    creativeEffect={{
                                        prev: {
                                            shadow: true,
                                            translate: [0, 0, -1000],
                                            opacity: .01
                                        },
                                        next: {
                                            translate: ['100%', 0, 0],
                                        },
                                    }}
                                    freeMode={true}
                                    speed={3000}
                                    modules={[Autoplay, EffectCreative]}
                                    className="mySwiper animate pop delay-1"
                                >
                                    <SwiperSlide>
                                        <Box className='text-title2'
                                            sx={{
                                                fontSize:{
                                                    sxs:'30px',
                                                    xs:'30px',
                                                    sm:'30px',
                                                    md:'38px',
                                                    lg:'38px',
                                                    xl:'38px',
                                                },
                                            }}>
                                            {t("home.textTitle1_1")} <br />
                                            {t("home.textTitle1_2")} <br />
                                            {t("home.textTitle1_3")} 
                                        </Box>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <Box className='text-title2'
                                            sx={{
                                                fontSize:{
                                                    sxs:'30px',
                                                    xs:'30px',
                                                    sm:'30px',
                                                    md:'38px',
                                                    lg:'38px',
                                                    xl:'38px',
                                                },
                                            }}>
                                            {t("home.textTitle2_1")} <br />
                                            {t("home.textTitle2_2")} <br />
                                            {t("home.textTitle2_3")} 
                                        </Box>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <Box className='text-title2'
                                            sx={{
                                                fontSize:{
                                                    sxs:'30px',
                                                    xs:'30px',
                                                    sm:'30px',
                                                    md:'38px',
                                                    lg:'38px',
                                                    xl:'38px',
                                                },
                                            }}>
                                            {t("home.textTitle3_1")} <br />
                                            {t("home.textTitle3_2")} <br />
                                            {t("home.textTitle3_3")} 
                                        </Box>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <Box className='text-title2'
                                            sx={{
                                                fontSize:{
                                                    sxs:'30px',
                                                    xs:'30px',
                                                    sm:'30px',
                                                    md:'38px',
                                                    lg:'38px',
                                                    xl:'38px',
                                                },
                                            }}>
                                            {t("home.textTitle4_1")} <br />
                                            {t("home.textTitle4_2")} <br />
                                            {t("home.textTitle4_3")} 
                                        </Box>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <Box className='text-title2'
                                            sx={{
                                                fontSize:{
                                                    sxs:'30px',
                                                    xs:'30px',
                                                    sm:'30px',
                                                    md:'38px',
                                                    lg:'38px',
                                                    xl:'38px',
                                                },
                                            }}>
                                            {t("home.textTitle5_1")} <br />
                                            {t("home.textTitle5_2")} <br />
                                            {t("home.textTitle5_3")} 
                                        </Box>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <Box className='text-title2'
                                            sx={{
                                                fontSize:{
                                                    sxs:'30px',
                                                    xs:'30px',
                                                    sm:'30px',
                                                    md:'38px',
                                                    lg:'38px',
                                                    xl:'38px',
                                                },
                                            }}>
                                            {t("home.textTitle6_1")} <br />
                                            {t("home.textTitle6_2")} <br />
                                            {t("home.textTitle6_3")} 
                                        </Box>
                                    </SwiperSlide>
                                </Swiper>
                                
                                <Button className='animate pop delay-2' variant="text" sx={{ ...constants.styles.secondaryButton, width:{
                                                    sxs:'80%',
                                                    xs:'60%',
                                                    sm:'55%',
                                                    md:'50%',
                                                    lg:'40%',
                                                    xl:'40%',
                                                } }} onClick={()=>handleClick_GetHeard()}>{t("home.btnGetHeard")}</Button>
                            </Box>
                        </Grid>
                        <Grid container direction='row'
                            size={{
                                sxs:0,
                                xs:0,
                                sm:5,
                                md:7,
                                lg:7,
                                xl:7,
                            }}
                            // sx={{
                            //     display: {
                            //             sxs:'none',
                            //             xs:'none',
                            //             sm:'block',
                            //             md:'block',
                            //             lg:'block',
                            //             xl:'block',
                            //         },
                            //     backgroundColor:'red',
                            // }}
                            sx={{zIndex:5}}
                        >
                            <Grid item size={7} sx={{
                                display: {
                                    sxs:'none',
                                    xs:'none',
                                    sm:'none',
                                    md:'block',
                                    lg:'block',
                                    xl:'block',
                                },
                                zIndex:6
                            }}>
                                <Swiper
                                    style={{width:'55%', marginTop:'42%', marginRight:'30px'}}
                                    effect='fade'
                                    grabCursor={true}
                                    centeredSlides={true}
                                    navigation={true}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    loop={true}
                                    autoplay={{
                                        disableOnInteraction: false,
                                        delay: 500,
                                    }}
                                    freeMode={true}
                                    speed={2000}
                                    modules={[Autoplay, EffectFade]}
                                    className="mySwiper animate pop delay-3"
                                >
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto1.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto3.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto5.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto7.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                </Swiper>
                            </Grid>
                            <Grid item size={{
                                    sxs:0,
                                    xs:0,
                                    sm:11,
                                    md:5,
                                    lg:5,
                                    xl:5
                                }}
                            >
                                <Swiper 
                                    style={{width:'80%', marginTop:'15%'}}
                                    effect='fade'
                                    grabCursor={true}
                                    centeredSlides={true}
                                    navigation={true}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    loop={true}
                                    autoplay={{
                                        disableOnInteraction: false,
                                        delay: 500,
                                    }}
                                    freeMode={true}
                                    speed={2000}
                                    modules={[Autoplay, EffectFade]}
                                    className="mySwiper animate pop delay-4"
                                >
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto2.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto4.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto6.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto8.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src='/assets/img/artists/foto9.png' style={{width:'100%'}} />
                                    </SwiperSlide>
                                </Swiper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box sx={{
                top: '550px',
                height: '100%',
                width: '100%',
                backgroundColor: '#313233',
                backgroundImage: "url('/assets/img/generic/fondo-black.svg')",
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                // position: 'absolute',
                zIndex:7,
            }}>
                <div style={{
                    margin: 0,
                    padding: 0,
                    border: 0,
                    width: '100%',
                    height: '110px',
                    display: 'block',
                    position: 'absolute',
                    backgroundImage: "url('/assets/img/generic/Roto2.svg')",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'left',
	                top: '490px',
                     zIndex: 9, 
                }}></div>

                <div style={{
                    fontSize:'35px',
                    fontWeight:'bold',
                    fontFamily:'arial',
                    color:'#FFFFFF',
                    textAlign: 'center',
                    width: '100%',
                    justifySelf:'center'
                }}>
                    <br />
                    <br />
                    <div className={slides<2 ? 'text-subtitle' : (slides===2 ? 'text-title2' : 'text-title')}>
                        {t("home.title1")} <br /> 
                        {t("home.title1_1")} 
                        <br/><br/>
                    </div>
                    <Grid container size={12}>
                        <Grid size={12} sx={{display:'flex', justifyContent:'center'}}>
                            <Swiper 
                                effect={'coverflow'}
                                grabCursor={true}
                                centeredSlides={true}
                                spaceBetween={50}
                                slidesPerView={slides}
                                loop={true}
                                coverflowEffect={{
                                    rotate: 50,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 1,
                                    slideShadows: false,
                                }}
                                autoplay={{
                                    disableOnInteraction: false,
                                    delay: 0,
                                }}
                                freeMode={true}
                                speed={3000}
                                // freeModeMomentum={false}
                                modules={[EffectCoverflow, Autoplay]}
                                className="mySwiper"
                                // onSlideChange={() => console.log('slide change')}
                                // onSwiper={(swiper) => console.log(swiper)}
                            >
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto11.jpg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto12.png' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto13.jpeg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                {/* <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto14.jpeg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide> */}
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto15.jpg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto16.png' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto17.jpeg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                {/* <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto18.jpeg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide> */}
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto19.jpg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto20.jpg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                                <SwiperSlide style={{width:'420px'}}><img src='/assets/img/artists/foto21.jpg' style={{width:'400px'}} className='swiper-slide-img' /></SwiperSlide>
                            </Swiper>
                        </Grid>
                        <Grid size={12} className='text-regular'>
                                <Box sx={{width:{
                                        sxs:'80%',
                                        xs:'80%',
                                        sm:'80%',
                                        md:'75%',
                                        lg:'60%',
                                        xl:'60%'
                                    }, justifySelf:'center', alignSelf:'flex-start'}}>
                                    <br />
                                    <div className='text-subtitle'>D Luna Music</div>
                                    {t("home.text1")}
                                    <br /><br />
                                    {t("home.text2")}
                                    <br />
                                    <b>{t("home.text3")}</b>
                                </Box>
                        </Grid>
                    </Grid>
                </div>
                <br />
                <div style={{
                    margin: 0,
                    padding: 0,
                    border: 0,
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    position: 'absolute',
                    backgroundImage: "url('/assets/img/generic/listArtist.svg')",
                    backgroundSize: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionY: '0px',
                    backgroundPositionX: 'right',
                }}></div>
                <br />
                <br />
                <br />
                <br />
                <br />
                
                    {slides > 1 ? <br /> : null}
                    {slides > 1 ? <br /> : null}
                    {slides > 1 ? <br /> : null}
                    {slides > 1 ? <br /> : null}
                    {slides > 1 ? <br /> : null}
                    {slides > 1 ? <br /> : null}
                    {slides > 1 ? <br /> : null}
                
                <div style={{
                    color:'#FFFFFF',
                    textAlign: 'center',
                    width: '100%',
                    justifySelf:'center'
                }}>
                    <div className={slides<2 ? 'text-subtitle' : (slides===2 ? 'text-title2' : 'text-title')}>
                        {t("home.title2")},<br />
                        {t("home.title2_1")}
                        <br /><br />
                    </div>
                    <Swiper 
                        grabCursor={true}
                        centeredSlides={true}
                        spaceBetween={50}
                        slidesPerView={slides>=3 ? 3 : (slides>1 ? 2 : 1)}
                        loop={true}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: false,
                        }}
                        autoplay={{
                            disableOnInteraction: false,
                            delay: 500,
                        }}
                        freeMode={true}
                        speed={5000}
                        // freeModeMomentum={false}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >
                        <SwiperSlide style={{width:'420px'}}>
                            <div className='text-regular' style={{textAlign:'left'}}>
                                <div className='bubble'>
                                    “{t("home.comment1")}”.
                                </div>
                                <p style={{fontSize:'10px',fontWeight:'normal', textAlign:'left', marginTop:'30px', marginLeft:'20px'}}>
                                    <b style={{fontSize:'14px'}}>{t("home.artist1")}</b>
                                    <br />
                                    {t("home.artistcaption")}
                                </p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide style={{width:'420px'}}>
                            <div className='text-regular' style={{textAlign:'left'}}>
                                <div className='bubble'>
                                    “{t("home.comment2")}”.
                                </div>
                                <p style={{fontSize:'10px',fontWeight:'normal', textAlign:'left', marginTop:'30px', marginLeft:'20px'}}>
                                    <b style={{fontSize:'14px'}}>{t("home.artist2")}</b>
                                    <br />
                                    {t("home.artistcaption")}
                                </p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide style={{width:'420px'}}>
                            <div className='text-regular' style={{textAlign:'left'}}>
                                <div className='bubble'>
                                    “{t("home.comment3")}".
                                </div>
                                <p style={{fontSize:'10px',fontWeight:'normal', textAlign:'left', marginTop:'30px', marginLeft:'20px'}}>
                                    <b style={{fontSize:'14px'}}>{t("home.artist3")}</b>
                                    <br />
                                    {t("home.artistcaption")}
                                </p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide style={{width:'420px'}}>
                            <div className='text-regular' style={{textAlign:'left'}}>
                                <div className='bubble'>
                                    “{t("home.comment4")}".
                                </div>
                                <p style={{fontSize:'10px',fontWeight:'normal', textAlign:'left', marginTop:'30px', marginLeft:'20px'}}>
                                    <b style={{fontSize:'14px'}}>{t("home.artist4")}</b>
                                    <br />
                                    {t("home.artistcaption")}
                                </p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide style={{width:'420px'}}>
                            <div className='text-regular' style={{textAlign:'left'}}>
                                <div className='bubble'>
                                    “{t("home.comment5")}".
                                </div>
                                <p style={{fontSize:'10px',fontWeight:'normal', textAlign:'left', marginTop:'30px', marginLeft:'20px'}}>
                                    <b style={{fontSize:'14px'}}>{t("home.artist5")}</b>
                                    <br />
                                    {t("home.artistcaption")}
                                </p>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <br /><br />
                {/* <br /><br />
                <Box sx={{
                    height: '270px',
                    width: {
                        sxs:'90%',
                        xs:'90%',
                        sm:"60%",
                        md:"60%",
                        lg:"70%",
                        xl:"70%",
                    },
                    padding:'30px',
                    backgroundColor: '#707071',
                    justifySelf: 'center',
                    borderTopLeftRadius: '40px',
                    borderTopRightRadius: '40px',
                    textAlign: 'center',
                    boxShadow: '6px 6px 6px rgb(28, 28, 28)'
                }}>
                    <div className={slides<2 ? 'text-regular2' : (slides===2 ? 'text-subtitle' : 'text-title2')} style={{color:'white'}}>{t("home.title3")}</div>
                    <br /><br />
                    {
                        slides > 1 ? 
                            <Grid container direction="row"
                                sx={{
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center',
                                }}
                            >
                                <img src='/assets/img/logo/spotify.png' style={{width:'100px'}} />
                                <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                <img src='/assets/img/logo/tiktok.png' style={{width:'50px'}} />
                                <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                <img src='/assets/img/logo/instagram.png' style={{width:'50px'}} />
                                <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                <img src='/assets/img/logo/facebook.png' style={{width:'50px'}} />
                                <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                <img src='/assets/img/logo/applemusic.png' style={{width:'100px'}} />
                            </Grid>
                        :
                            <div>
                                <Grid container direction="row"
                                    sx={{
                                        justifyContent: 'space-evenly',
                                        alignItems: 'center',
                                    }}
                                >
                                    <img src='/assets/img/logo/spotify.png' style={{width:'100px'}} />
                                    <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                    <img src='/assets/img/logo/applemusic.png' style={{width:'100px'}} />
                                </Grid>
                                <br />
                                <Grid container direction="row"
                                    sx={{
                                        justifyContent: 'space-evenly',
                                        alignItems: 'center',
                                    }}
                                >
                                    <img src='/assets/img/logo/tiktok.png' style={{width:'50px'}} />
                                    <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                    <img src='/assets/img/logo/instagram.png' style={{width:'50px'}} />
                                    <Divider orientation="vertical" variant="middle" flexItem sx={{borderColor:'#929292'}} />
                                    <img src='/assets/img/logo/facebook.png' style={{width:'50px'}} />
                                </Grid>
                            </div>
                    }
                    
                </Box> */}
                <Footer />
            </Box>
        </>
    )
}
